import { Calendar } from 'primereact/calendar';
import React, { useLayoutEffect, useState, useRef } from 'react';
import { DataTable, Column } from '../PrimeReact.js';
import GV from '../../services/globalVar';
import { startOfWeek, lastDayOfWeek, format } from "date-fns";
import PettycashServiceService from '../../services/pettycash-service';
import { useNavigate } from 'react-router';

export default function PettyCashReport() {
    const pts = new PettycashServiceService();

    const [dates, setDates] = useState();
    const [cashReport, setCashReport] = useState([]);
    const [currentMonth, setCurrentMonth] = useState(new Date());
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const navigate = useNavigate();

    // DataTable ref for export
    const dt = useRef(null);

    const renderCells = (mon) => {
        const sdate = startOfWeek(currentMonth, { weekStartsOn: 1 });
        const edate = lastDayOfWeek(currentMonth, { weekStartsOn: 1 });
        setStartDate(sdate);
        setEndDate(edate);
        setDates([sdate, edate]);
        fetchDetails(sdate, edate);
    };

    const fetchDetails = (start, end) => {
        const data = {
            "TenantID": GV.userDet.tenantDetail.tenantID,
            "FromDate": format(start, 'yyyy-MM-dd'),
            "ToDate": format(end, 'yyyy-MM-dd'),
            "Status": "Active"
        };
        pts.GetCustomTransactions(data).then(res => {
            setCashReport(res.data.data);
        });
    };

    const changeDuration = (val) => {
        setDates(val);
        if (val[0] != null && val[1] != null) {
            fetchDetails(val[0], val[1]);
        }
    };

    const backtopetty = () => {
        navigate('/pettycash');
    };

    const amountbody = (data) => {
        return (<p>{format(new Date(data.transactionDate), GV.userDet.tenantConfig.dateFormat)}</p>);
    };

    const exportCSV = () => {
        if (dt.current) {
            dt.current.exportCSV();
        }
    };

    useLayoutEffect(() => {
        renderCells(currentMonth);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <div className='card card-borderless cc-greyCard-custm'>
                <div className='ms-2 mt-2 me-2'>
                    <div className='d-flex justify-content-between align-items-center mb-2 flex-wrap'>
                        <h4 className="m-0">Petty Cash Report</h4>
                        <div className='cc-calen d-flex align-items-center'>
                            <Calendar
                                className='me-2'
                                showIcon
                                value={dates}
                                onChange={(e) => changeDuration(e.value)}
                                selectionMode="range"
                                dateFormat={GV.userDet.tenantConfig.dateFormat === 'MM/dd/yyyy' ? 'mm/dd/yy' : 'dd/mm/yy'}
                                style={{ width: '250px' }}
                            />

                            <button
                                className="btn btn-success me-2 d-flex align-items-center"
                                onClick={exportCSV}
                                disabled={!cashReport || cashReport.length === 0}
                            >
                                <i className="pi pi-file-excel me-2"></i> Export
                            </button>

                            <button className='btn btn-danger my-2' onClick={backtopetty}>
                                Back
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="bg-white shadow-sm chart-of-account h-100 cc-greyCard-custm1">
                <div className="row coa-header kk-header-sec">
                    <div className="col-auto header-right ms-auto"></div>
                </div>
                <div className="account-table">
                    <DataTable
                        ref={dt}
                        stripedRows
                        value={cashReport}
                        className=''
                        paginator
                        rows={10}
                        emptyMessage="No data found"
                    >
                        <Column field="transaction" header="Transaction"></Column>
                        <Column field="transactionCode" header="Code"></Column>
                        <Column header="Transaction Date" body={amountbody}></Column>
                        <Column field="receiver" header="Receiver"></Column>
                        <Column
                            field="amountPaid"
                            className="text-end amount-align"
                            header="Amount Paid"
                            body={(row) => GV.userDet.tenantConfig.currency + " " + row.amountPaid.toFixed(2)}
                        ></Column>
                        <Column field="isGST" header="GST"></Column>
                        <Column field="description" header="Description"></Column>
                    </DataTable>
                </div>
            </div>
        </div>
    );
}
